<template>
    <div id="app">
        <router-view/>
    </div>
</template>
<script>
import Locale from '@/helper/locale/locale.js';
import Util from '@/helper/Utility.js'; 

export default {
    name: 'App',
    data: function() {
        return {
            localeCode: Locale.getLocaleCode(),
        };
    },
    created: function() {
        this.setLocaleFont();
        Util.disableZoom();
    },
    mounted: function() {
        var self = this;
      
        this.localeCheckInterval = setInterval(function() {
            var newLocaleCode = Locale.getLocaleCode();
            if (self.localeCode !== newLocaleCode) {
                self.localeCode = newLocaleCode;
                self.setLocaleFont();
            }
        }, 300);
    },
    beforeDestroy: function() {
        if (this.localeCheckInterval) {
            clearInterval(this.localeCheckInterval);
        }
    },
    methods: {
        setLocaleFont: function() {
            const localeCode = Locale.getLocaleCode();
            const body = document.body;
            
            if (localeCode === 1054 || localeCode === '1054') {
                body.classList.add('font-th');
                body.classList.remove('font-en');
            } else {
                body.classList.add('font-en');
                body.classList.remove('font-th');
            }
        }
    }
}
</script>
<style lang="scss">
    @import "@/style/main.scss";
</style>